exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#application-wrapper[data-v-5afeb3fb]{overflow:hidden}", ""]);

// exports
